module.exports = __webpack_public_path__ + "img/sch1-gift2-img.ca59f93b.png";